export default __webpack_public_path__ + "static/media/produto-vinho2.0a51d7df.png";